/**
 * @deprecated This file is kept for backward compatibility.
 * Please use ApolloProviderWrapper from "./components" or useApolloClient hook from "./hooks" instead.
 */
import { ApolloClient } from "apollo-client";
import { setContext } from "apollo-link-context";
import { createHttpLink } from "apollo-link-http";
import { Auth } from "aws-amplify";
import { createApolloCache, apolloResolvers } from "./config";
import { isTreezSSOEnabled } from "auth";

const httpLink = createHttpLink({
    uri: process.env.REACT_APP_GRAPHQL_ENDPOINT_URL,
});

const authLink = setContext(async (_, { headers }) => {
    let token = null;

    if (isTreezSSOEnabled) {
        // Read token dynamically from localStorage (stored by AuthProvider)
        try {
            const treezTokenStr = localStorage.getItem("treez_token");
            if (treezTokenStr) {
                const treezToken = JSON.parse(treezTokenStr);
                const treezAccessToken = treezToken?.accessToken;
                if (treezAccessToken) {
                    token = `Treez ${treezAccessToken}`;
                }
            }
        } catch (error) {
            console.warn("Error reading Treez token from localStorage:", error);
        }
    } else {
        try {
            const congnitoUser = await Auth.currentAuthenticatedUser();
            token = congnitoUser.signInUserSession.accessToken.jwtToken;
        } catch (error) {
            // User not authenticated
            console.warn("Cognito user not authenticated:", error);
        }
    }

    return {
        headers: {
            ...headers,
            ...(token && { Authorization: token }),
        },
    };
});

const cache = createApolloCache();

const data = new ApolloClient({
    link: authLink.concat(httpLink),
    cache,
    resolvers: apolloResolvers,
});

export default data;
